import {fetchQuery, type GraphQLTaggedNode, type OperationType} from 'relay-runtime'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {clientSideRelayFetchQueryRetained} from '@github-ui/relay-environment'
import {INTERNAL_ONLY_ATTRIBUTES} from './create-query-cache'
import {DEFAULT_RELAY_CACHE_TTL, getDefaultValues} from './helpers'

export function fetchQueryWithCache<T extends OperationType>(
  ...args: [...Parameters<typeof fetchQuery<T>>, number?, string?, boolean?, string[]?, boolean?]
) {
  const [environment, query, variables, options, ttl, preheatSource, skipCache, excludeFromCacheKey, skipNetwork] = args
  const defaultValues = getDefaultValues(query)

  return fetchQuery<T>(environment, query, variables, {
    ...options,
    networkCacheConfig: {
      metadata: {
        ttl,
        defaultValues,
        preheatSource,
        skipCache,
        [INTERNAL_ONLY_ATTRIBUTES.EXCLUDE_FROM_CACHE_KEY]: excludeFromCacheKey,
        [INTERNAL_ONLY_ATTRIBUTES.SKIP_NETWORK]: skipNetwork,
      },
    },
  })
}

export function clientSideRelayFetchQueryRetainedWithCache<T extends OperationType>(
  ...args: [...Parameters<typeof clientSideRelayFetchQueryRetained<T>>, number?, string[]?]
) {
  const [options, ttl, excludeFromCacheKey] = args
  const defaultValues = getDefaultValues(options.query)

  return clientSideRelayFetchQueryRetained<T>({
    ...options,
    metadata: {
      ...options.metadata,
      ttl,
      defaultValues,
      [INTERNAL_ONLY_ATTRIBUTES.EXCLUDE_FROM_CACHE_KEY]: excludeFromCacheKey,
    },
  })
}

type CacheForceRefreshProps = {
  query: GraphQLTaggedNode
  number: number
  owner: string
  repo: string
  tabbedTimeline?: boolean
  viewType?: string
}

export function cacheForceRefresh(
  relayEnvironment: Parameters<typeof fetchQuery>[0],
  {query, number, owner, repo, tabbedTimeline, viewType}: CacheForceRefreshProps,
) {
  const variables = {
    owner,
    repo,
    number,
    count: 15,
    ...(tabbedTimeline != null ? {tabbedTimeline} : {}),
    ...(viewType ? {viewType} : {}),
  }

  fetchQueryWithCache(
    relayEnvironment,
    query,
    variables,
    {fetchPolicy: 'network-only'},
    DEFAULT_RELAY_CACHE_TTL,
    'force_refresh',
    true, // Skip cache
  ).toPromise()
}
